let code = 'iggestao';
let codeAPI = 'ig';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};